import { Component, OnInit,Input } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-navbar-prod',
  templateUrl: './navbar-prod.component.html',
  styleUrls: ['./navbar-prod.component.scss'],
})
export class NavbarProdComponent implements OnInit {
  @Input()titulo;
  constructor(private route:NavController) { }

  ngOnInit() {}
  close(){

    this.route.navigateForward(['/'])
  }

}
